import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { CommissionAdditionalPromotor } from 'src/app/model/commission-additional-promotor.model';
import { CommissionAdjustment } from 'src/app/model/other-catalogs-models';

@Injectable({
  providedIn: 'root'
})
export class ComisionSimuladorService {

  private url: string;

  constructor(private http: HttpClient) {
    this.url = environment.services_url;
  }

  getCommissionCollectPromotorDirect = (simulateDate: string, simulateId: number) => {
    //return this.http.get(`${this.url}/CommissionProductEmployeeJobWH/CommissionCollectPromotorDirect?simulateDate=${simulateDate}&simulateId=${simulateId}`)
    return this.http.get(`${this.url}/CommissionProductEmployeeJobWH/CommissionCollectPromotorDirect2?simulateDate=${simulateDate}&simulateId=${simulateId}&incluirAntiguos=false`)
      .pipe(
        map((resp: any) => resp)
      );
  }

  getCommissionCollectPromotorDirect2 = (simulateDate: string, simulateId: number, incluirAntiguos: boolean) => {
    //return this.http.get(`${this.url}/CommissionProductEmployeeJobWH/CommissionCollectPromotorDirect?simulateDate=${simulateDate}&simulateId=${simulateId}`)
    return this.http.get(`${this.url}/CommissionProductEmployeeJobWH/CommissionCollectPromotorDirect2?simulateDate=${simulateDate}&simulateId=${simulateId}&incluirAntiguos=${incluirAntiguos}`)
      .pipe(
        map((resp: any) => resp)
      );
  }

  calculateCommissionsByDateRange = (payload: {
    startDate: string,    // 'YYYY-MM-DD HH:mm:00'
    endDate: string,      // 'YYYY-MM-DD HH:mm:00'
    esSimulacion: boolean,
    aplicarRetenciones: boolean,
    aplicarLiberaciones: boolean,
    aplicarMetas: boolean,
    aplicarMetasAutorizadas: boolean
  }) => {
    console.log('Payload /aplicarCalculoByDateRange:', payload);
    return this.http.post(
      `${this.url}/CommissionProductEmployeeJobWH/aplicarCalculoByDateRange`,
      payload
    ).pipe(
      map((resp: any) => resp)
    );
  }

  // calculateCommissionsByDateRangeDebug = (payload: {
  //   startDate: string,    // 'YYYY-MM-DD HH:mm:00'
  //   endDate: string,      // 'YYYY-MM-DD HH:mm:00'
  //   esSimulacion: boolean,
  //   aplicarRetenciones: boolean,
  //   aplicarLiberaciones: boolean,
  //   aplicarMetas: boolean,
  //   aplicarMetasAutorizadas: boolean,
  // }) => {
  //   console.log('Payload /aplicarCalculoByDateRange:', payload);
  //   return this.http.post(
  //     `${this.url}/CommissionProductEmployeeJobWH/aplicarCalculoByDateRange`,
  //     payload
  //   ).pipe(
  //     map((resp: any) => resp)
  //   );
  // }

  getTaskStatus = (sessionId: string, activeLog: boolean) => {
    return this.http.get(`${this.url}/CommissionProductEmployeeJobWH/findResultCalculoComisiones?sessionId=${sessionId}&activeLog=${activeLog}`)
      .pipe(
        map((resp: any) => resp)
      );
  }

  saveCommissionAdjustment = (commissionAdjustment: CommissionAdjustment) => {
    return this.http.post(`${this.url}/CommissionCollect/saveCommissionAdjustment`, commissionAdjustment)
      .pipe(
        map((resp: any) => resp)
      );
  }

  saveCommissionCaneAdditionalPromotor = (commissionPromotor: CommissionAdditionalPromotor) => {
    return this.http.post(`${this.url}/CommissionCollect/saveCommissionCaneAdditionalPromotor`, commissionPromotor)
      .pipe(
        map((resp: any) => resp)
      );
  }
}
